import { EbLabel } from './label';
import { EbEtablissement } from './etablissement';


export class EbCategorie {

    ebCategorieNum: number;
    libelle: string;
    etablissement: EbEtablissement;
    labels :  Array<EbLabel>;
    selectedLabel: EbLabel;

    constructor() {

        this.ebCategorieNum = null;
        this.libelle = null;
        this.etablissement = null;
        this.labels = new Array<EbLabel>();
        this.selectedLabel = null;
     }

     constructorCopy(ebCategorie:EbCategorie)
     {

         this.constructor();
         this.ebCategorieNum = ebCategorie.ebCategorieNum;
         this.libelle = ebCategorie.libelle;
         if(ebCategorie.etablissement != null)
         {
            ebCategorie.etablissement.categories = null;
             this.etablissement = ebCategorie.etablissement;
         }
         this.labelCopy(ebCategorie.labels);
     }

     constructorCopyLite(ebCategorie:EbCategorie)
     {
         this.constructor();
         this.ebCategorieNum = ebCategorie.ebCategorieNum;
         this.libelle = ebCategorie.libelle;
     }

     labelCopy(labels: Array<EbLabel>) {
        let _label;
        if (labels !== undefined && labels !== null && labels.length !== 0) {
            for (let label of labels) {
                _label = new EbLabel();
                _label.constructorCopy(label);
                this.labels.push(_label);
            }
        }
        else {
            this.labels = new Array<EbLabel>();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/classes/categorie.ts